/* v8 ignore start -- enum declaration: no logic to cover */
export enum DeviceTypes {
  MOBILE,
  TABLET,
  DESKTOP,
}
/* v8 ignore stop */
